module.exports = __webpack_public_path__ + "static/media/pic.3f6220a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/pic.png
// module id = 366
// module chunks = 0